'use client';
import { useEffect, useState } from 'react';
import { CONSENT_CHANGE_EVENT, getConsent } from '@/utils/cookieConsent';
import GoogleTagScripts from './GoogleTagScripts';

function hasRequiredConsent(googleTag, consent) {
    if (!consent) return false;
    if (googleTag.startsWith('AW-')) return consent.marketing;
    if (googleTag.startsWith('GTM-'))
        return consent.analytics || consent.marketing;
    return consent.analytics; // G-, UA-
}

export default function GoogleTagScriptsGated({ googleTag, consentEnabled }) {
    const [allowed, setAllowed] = useState(!consentEnabled);

    useEffect(() => {
        if (!consentEnabled || !googleTag) return undefined;

        const evaluate = () =>
            setAllowed(hasRequiredConsent(googleTag, getConsent()));
        evaluate();

        window.addEventListener(CONSENT_CHANGE_EVENT, evaluate);
        return () => window.removeEventListener(CONSENT_CHANGE_EVENT, evaluate);
    }, [consentEnabled, googleTag]);

    if (!googleTag || !allowed) return null;
    return <GoogleTagScripts googleTag={googleTag} />;
}
